import React, { useState, useEffect, useCallback, useMemo } from 'react';

import { formatedNumber } from '../../Functions/convertNumber';
import { formatedDateClient } from '../../Functions/convertDate';
import { HandlePrint } from '../../Functions/printfacturebrowser';
import { saveFacturePDF } from '../../Functions/savefacturePDF';
import { handleExport } from '../../Functions/exportFactureEtablieExcel';

import { fetchFactureById } from '../../API/fetchFactureById';

import EditFactureModal from './EditFacture';

import '../../Css/FactureEtablie.css';

const FacturesTable = () => {
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rowspage, setRowsPage ] = useState(12);
    const [filters, setFilters] = useState({
        id: "",
        organisme: "",
        NFacture: "",
        hotel: "",
        nbrfact: "",
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0],
        solde: "",
        Achat: "",
        ecart: "",
        commission: "",
        tva: "",
        operateur: "",
    });

    const [currentPage, setCurrentPage] = useState(0);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedFacture, setSelectedFacture] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFactureId, setSelectedFactureId] = useState('');

    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;


    const handleFilterChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setFilters((prev) => ({ ...prev, [name]: value }));
        },
        [setFilters]
    );




    const printfacture = async(facture_id) => {
        const factures = await fetchFactureById(facture_id);
        HandlePrint(factures);
    };




    const savefactureInPDF = async(facture_id) => {
        const factures = await fetchFactureById(facture_id);
        saveFacturePDF(factures);
    };




    const editFacture = async (facture_id) => {
        const factures = await fetchFactureById(facture_id);
        setSelectedFacture(factures); 
        setIsEditModalOpen(true);
    };



    const handleSaveChanges = (updatedFacture) => {
        // Save the updated facture here (you can either update it locally or make an API call)
        setFactures((prevFactures) =>
          prevFactures.map((facture) =>
            facture.id_facture === updatedFacture.id_facture ? updatedFacture : facture
          )
        );
        setIsEditModalOpen(false); // Close the modal
      };





      // Open the modal
  const openModal = (factureId) => {
    setSelectedFactureId(factureId);
    setIsModalOpen(true);
  };


  // Close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedFactureId(null);
  };

    



    const handleSearchClick = () => {
        fetchData();
    };




  const handleKeyPress = useCallback((event) => {
    if (event.key === 'Enter') {
      fetchData();
    }
  },);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);


  useEffect(() => {
    fetchData();
  }, []);




    // Handle change Montant_achat field
    const handleRowsPageChange = (e) => {
        let value = e.target.value;
         setRowsPage(value);
    };




    const paginateData = useMemo(() => {
            const sortedFactures = [...factures].sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
        
            const startIndex = (currentPage - 1) * rowspage;
            const endIndex = startIndex + parseInt(rowspage);
            return sortedFactures.slice(startIndex, endIndex);
    }, [factures, currentPage, rowspage]);


    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);
      
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year}  ${hours}:${minutes}`;
      }

    

    // Action handlers
    const exportTableInExcel = () => handleExport(factures);

    // Handle pagination buttons (Next, Prev, etc.)
    const totalPages = Math.ceil(factures.length / rowspage);
    const goToPage = (page) => setCurrentPage(page);

    // Disable Prev/Next if no data
    const isPrevDisabled = currentPage === 1 || factures.length === 0;
    const isNextDisabled = currentPage === totalPages || factures.length === 0;


      const fetchData = async () => {
        setLoading(true);
        setError(null); 

        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });

            const facturesRes= await fetch(`${apiUrl}/api/detail/facture?${params.toString()}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
            });


            if (!facturesRes.ok) {
                throw new Error("Failed to fetch data");
            }

            const facturesData = await facturesRes.json();

            setFactures(facturesData);

            if(facturesData.length > 0){
                setCurrentPage(1);
            }

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className='Facturetablie__ErrorAPI'>Error: {error}</div>;
    }

return (
<div className="Facturetablie">
    <h2 className="Facturetablie__title">Factures établies</h2>

    <div className="Facturetablie__filterSection1">
        <div className='Facturetablie__SearchDtate'>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="startDate">Start Date</label>
                <input
                   type="date"
                   id="startDate"
                   className="Facturetablie__filterInput"
                   name="startDate"
                   value={filters.startDate}
                   onChange={handleFilterChange}
                />
            </div>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="endDate">End Date</label>
                <input
                   type="date"
                   id="endDate"
                   className="Facturetablie__filterInput"
                   name="endDate"
                   value={filters.endDate}
                   onChange={handleFilterChange}
                />
            </div>
        </div>
        <div className='Facturetablie__filterSection'>
            {[
                { filter: "organisme", label: "Organisme" },
                { filter: "NFacture", label: "N° Facture" },
                { filter: "hotel", label: "Hôtel" },
                { filter: "nbrfact", label: "N° Fct Achat" },
                { filter: "solde", label: "Mnt Vente" },
                { filter: "Achat", label: "Mnt Achat" },
                { filter: "commission", label: "Commission" },
                { filter: "operateur", label: "Operateur" },
            ].map(({ filter, label, index }) => (
        <div 
            className="Facturetablie__filterGroup1" 
            key={index}
        >
            <label htmlFor={label}>{label}</label>
            <input
                className="Facturetablie__filterInput"
                type='text'
                name={filter}
                id={filter}
                value={filters[filter]}
                onChange={handleFilterChange}
                placeholder='filter'
            />
        </div>
    ))}
</div>
        <button className="Facturetablie__searchButton" onClick={handleSearchClick}>Search</button>
    </div>

    <div className="Facturetablie__exportation">
        <button className="Facturetablie__exportButton" onClick={exportTableInExcel}>Exporter en Excel</button>
    </div>


    {/* Pagination */}
    <div className='Facturetablie__paginationarea'>
        <div className="Facturetablie__pagination">
           <button disabled={isPrevDisabled} onClick={() => goToPage(currentPage - 1)}>&lt; Prev</button>
           <span>Page {currentPage} of {totalPages}</span>
           <button disabled={isNextDisabled} onClick={() => goToPage(currentPage + 1)}>Next &gt;</button>

           <input
            type="text"
            className="Facturetablie__rowspage"
            value={rowspage}
            onChange={handleRowsPageChange}
        />
        </div>
    </div>

            <table className="Facturetablie__table">
                <thead>
                <tr className="Facturetablie__headerRow">
                {[
                    { name: "date", label: "Date" },
                    { name: "organisme", label: "Organisme" },
                    { name: "id_facture", label: "N° Facture" },
                    { name: "hotel", label: "Hôtel" },
                    { name: "nbrfact", label: "N° Fct Achat" },
                    { name: "solde", label: "Mnt Vente" },
                    { name: "montantAchat", label: "Mnt Achat" },
                    { name: "ecart", label: "Ecart" },
                    { name: "commission", label: "Commission" },
                    { name: "comtax", label: "Tva" },
                    { name: "tva", label: "Tax" },
                    { name: "timbre", label: "Timbre" },
                    { name: "updateAt", label: "Date mise à jour" },
                    { name: "observation", label: "Observation" },
                    { name: "operateur", label: "Opérateur" },
                ].map(({ name, label }) => (
                    <th key={name}>{label}</th>
                ))}

               <th className='Facturetablie__center'>Actions</th>
            </tr>
                </thead>

        <tbody>
            {paginateData.length > 0 ? (
                paginateData.map((item) => (
                    <tr key={item.id} className="facturesContainer__row">
                        <td className='center-text'>{formatedDateClient(item.currentDate)}</td>
                        <td>{item.selectedorganisme}</td>
                        <td>{item.id_facture}</td>
                        <td>{item.selectedHotel}</td>
                        <td>{item.nbrfact}</td>
                        <td>{formatedNumber(item.solde)}</td>
                        <td>{formatedNumber(item.montantAchat)}</td>
                        <td>{formatedNumber(item.ecart)}</td>
                        <td>{formatedNumber(item.commission)}</td>
                        <td>{formatedNumber(item.comtax)}</td>
                        <td>{formatedNumber(item.tva)}</td>
                        <td>{formatedNumber(item.timbre)}</td>
                        <td>{formatTimestamp(item.updatedAt)}</td>
                        <td style={{ width: '150px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                            {item.observation}
                        </td>
                        <td>{item.operateur}</td>
                        <td className='Facturetablie__buttonarea'>
                          <div className="action-buttons"> 
                            <button className="facturesContainer__printButton" onClick={() => printfacture(item.id_facture)}>
                                Print
                            </button>
                            <button className="facturesContainer__exportPDF" onClick={() => savefactureInPDF(item.id_facture)}>
                                PDF
                            </button>
                            <button className="facturesContainer__editFacture" onClick={() => editFacture(item.id_facture)}>
                               Edit
                            </button>
                            </div>
                        </td>
                    </tr>
                ))
            ) : (
                <tr><td colSpan="16" className='not-found'>No results found.</td></tr>
            )}
        </tbody>
            </table>


        {isEditModalOpen && (
            <EditFactureModal
              factures={selectedFacture}  // The facture being edited
              isOpen={isEditModalOpen}     // Whether the modal is visible
              onClose={() => setIsEditModalOpen(false)}  // Function to close the modal
              onSave={handleSaveChanges}  // Function to save the edited facture
            />
          )}
</div>

    );
};

export default FacturesTable;




